'use client'
import { useEffect, useState } from 'react'

import { cn } from '../../utils/cn'

const Dot = ({ active }: { active: boolean }) => (
  <div
    className={cn(
      "flex size-3 shrink-0 items-center justify-center rounded-full bg-gray-05 shadow-[1px_1px_3px_rgba(0,0,0,0.1)_inset] after:block after:size-2 after:rounded-full after:bg-gradient-primary after:transition-opacity after:content-['']",
      {
        'after:opacity-0': !active,
        'after:opacity-100': active,
      },
    )}
  />
)

export const Dots = ({
  className,
  count,
  value,
  animationDelay = 200,
}: {
  className?: string
  count: number
  value: number
  animationDelay?: number
}) => {
  const [innerValue, setInnerValue] = useState(0)

  useEffect(() => {
    const timers = Array.from({ length: value }, (_, i) =>
      setTimeout(() => setInnerValue(i + 1), animationDelay * i),
    )

    return () => {
      timers.forEach((timer) => clearTimeout(timer))
    }
  }, [value, animationDelay])

  return (
    <div className={cn('flex gap-1', className)}>
      {Array.from({ length: count }, (_, i) => (
        <Dot active={i < innerValue} key={i} />
      ))}
    </div>
  )
}
